import React from 'react';
import { Button } from './Button';
import { MenuIcon } from 'lucide-react';
import { t } from '../src/locales';
export const Navbar = () => {
  return <header className="w-full bg-white py-6 px-6 md:px-12 flex justify-between items-center" data-id="element-99">
      <div className="flex items-center" data-id="element-100">
        <h1 className="text-[#192636] text-2xl font-[200]" data-id="element-101">
          {t('navbar.logo')}
        </h1>
      </div>
      <div className="hidden md:flex items-center space-x-8" data-id="element-102">
        <a href="#benefits" className="text-[#192636] text-sm" data-id="element-103">
          {t('navbar.benefits')}
        </a>
        <a href="#features" className="text-[#192636] text-sm" data-id="element-104">
          {t('navbar.features')}
        </a>
        <a href="#testimonials" className="text-[#192636] text-sm" data-id="element-105">
          {t('navbar.testimonials')}
        </a>
        <Button data-id="element-106">{t('navbar.tryMoonbird')}</Button>
      </div>
      <div className="md:hidden" data-id="element-107">
        <MenuIcon className="text-[#192636]" data-id="element-108" />
      </div>
    </header>;
};